import { render } from "./qr-code.vue?vue&type=template&id=25b306d4&scoped=true"
import script from "./qr-code.vue?vue&type=script&lang=js"
export * from "./qr-code.vue?vue&type=script&lang=js"

import "./qr-code.vue?vue&type=style&index=0&id=25b306d4&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b306d4"]])

export default __exports__